<template>
    <div>
        <b-card
            border-variant="info"
            header-bg-variant="primary"
            header-text-variant="white"
            class="full-width"
            v-if="thankOrEdit"
        >
            <v-dialog v-model="loading" fullscreen full-width>
                <v-container
                    fluid
                    fill-height
                    style="background-color: rgba(255, 255, 255, 0.5)"
                >
                    <v-layout justify-center align-center>
                        <v-progress-circular
                            indeterminate
                            color="primary"
                        ></v-progress-circular>
                    </v-layout>
                </v-container>
            </v-dialog>
            <div slot="header" style="position: relative">
                <strong style="font-size: 20px">View Office</strong>
                <b-button variant="primary" class="back button" @click="done()">
                    Back
                </b-button>
            </div>
            <div>
                <h3 style="color: #2c8ef8; margin-bottom: 20px">Office</h3>
                <b-row class="align-items-center">
                    <b-col md="3">
                        <eb-select
                            disabled
                            type="text"
                            label="label"
                            placeholder="Select Category"
                            v-model="office.officeType"
                            :options="officeOptions"
                            :selected="office.officeType"
                        ></eb-select>
                    </b-col>
                    <b-col md="4">
                        <slot name="name">
                            <c-input
                                readonly
                                inputType="text"
                                inputId="userName"
                                lableText="Office Name"
                                v-model="office.officeName"
                            />
                        </slot>
                    </b-col>
                    <b-col md="5">
                        <div
                            v-for="(p, idx) in office.phone"
                            :key="idx"
                            class="d-flex align-items-center"
                        >
                            <div class="flex-grow-1 pr-2">
                                <c-tel-input
                                    disabled
                                    v-model="p.number"
                                    @validate="(e) => isValidate(e, p)"
                                    :defaultInput="p.number"
                                />
                            </div>
                            <!-- <div>
                                <b-button
                                    :class="[
                                        'add button',
                                        p.isRemovable
                                            ? 'btn-danger'
                                            : 'btn-primary',
                                    ]"
                                    size="lg"
                                    @click="onClickPhoneButton(p, idx)"
                                >
                                    <i
                                        :class="
                                            p.isRemovable
                                                ? 'fa fa-minus-circle mr-1'
                                                : 'fa fa-plus-circle mr-1'
                                        "
                                    ></i>
                                    {{ p.text }}
                                </b-button>
                            </div> -->
                        </div>
                    </b-col>
                </b-row>
                <!-- //////////////// -->
                <b-row>
                    <b-col md="3">
                        <eb-select
                            disabled
                            label="name"
                            @input="getCountry"
                            :options="countries"
                            placeholder="Country"
                            :selected="office.address.country"
                        ></eb-select>
                    </b-col>
                    <b-col md="4">
                        <eb-select
                            disabled
                            label="name"
                            @input="getState"
                            :options="states"
                            placeholder="State"
                            :selected="office.address.state"
                        ></eb-select>
                    </b-col>
                    <b-col md="5">
                        <div
                            v-for="(e, idx) in office.email"
                            :key="idx"
                            class="d-flex align-items-center mb-2"
                        >
                            <div class="flex-grow-1 pr-2">
                                <c-input
                                    readonly
                                    inputType="text"
                                    inputId="email"
                                    lableText="Email"
                                    v-model="e.mailId"
                                />
                            </div>
                            <!-- <div>
                                <b-button
                                    :class="[
                                        'add button',
                                        e.isRemovable
                                            ? 'btn-danger'
                                            : 'btn-primary',
                                    ]"
                                    size="lg"
                                    @click="onClickEamilButton(e, idx)"
                                >
                                    <i
                                        :class="
                                            e.isRemovable
                                                ? 'fa fa-minus-circle mr-1'
                                                : 'fa fa-plus-circle mr-1'
                                        "
                                    ></i>
                                    {{ e.isRemovable ? "minus" : "Add" }}
                                </b-button>
                            </div> -->
                        </div>
                    </b-col>
                </b-row>

                <!-- //////////// -->
                <b-row>
                    <b-col md="3">
                        <eb-select
                            disabled
                            placeholder="City"
                            :options="cities"
                            label="name"
                            @input="getCity"
                            :selected="office.address.city"
                        ></eb-select>
                    </b-col>
                    <b-col md="4">
                        <c-input
                            readonly
                            type="text"
                            inputId="zipcode"
                            v-model="office.address.zip"
                            lableText="Zipcode"
                        />
                    </b-col>
                    <!-- <b-col md="4">
            <c-input
              type
              inputId="street"
              lableText="Street Line 1"
              v-model="office.address.street1"
            />
          </b-col> -->
                    <!-- <b-col md="4">
            <c-input
              inputType="text"
              inputId="address"
              lableText="Street Line 2"
              v-model="office.address.street2"
            />
          </b-col> -->
                </b-row>
                <!-- ///////////// -->
                <b-row>
                    <!-- <b-col md="4">
            <c-input
              type="text"
              inputId="hno"
              v-model="office.address.houseNumber"
              lableText="House Number"
            />
          </b-col> -->
                </b-row>
            </div>
            <!-- ///////////////////////////////////////////////////////////////////////////////////// -->
            <hr style="border-top: 1px solid var(--primary)" class="mt-4" />
            <!-- //////////////////////////////////////////////////////////////////////////////// -->
            <div>
                <h3 style="color: #2c8ef8; margin-bottom: 20px">
                    Organization
                </h3>
                <b-row class="mt-3">
                    <b-col md="2" class="mt-2"
                        ><img
                            :src="organization.logo.url"
                            alt="Organization Logo"
                            class="img-thumbnail mb-3"
                    /></b-col>
                    <b-col md="5" class="ml-5">
                        <b-row>
                            <b-col md="6" >
                                <c-input-form
                                    inputType="text"
                                    inputId="OrganizationName"
                                    lableText="Organization Name"
                                    v-model="organization.name"
                                    class="mt-1"
                                    :disabled="true"
                                />
                            </b-col>
                            <b-col md="6"
                                ><c-input
                                    inputType="text"
                                    :inputId="`registrationNo`"
                                    lableText="Registration No *"
                                    v-model="organization.registrationNo"
                                    class="mt-0"
                                    readonly
                            /></b-col>
                            <b-col md="6"
                                ><c-input
                                    inputType="text"
                                    :inputId="`gstNo`"
                                    lableText="GST No *"
                                    v-model="organization.gstNo"
                                    class="mt-0"
                            /></b-col>
                            <b-col md="6"
                                ><c-input
                                    inputType="text"
                                    :inputId="`fssciNo`"
                                    lableText="FSSAI  No "
                                    v-model="organization.fssciNo"
                                    class="mt-0"
                            /></b-col>
                            <b-col md="6"
                                ><b-form-checkbox
                                    disabled
                                    switch
                                    v-model="organization.isOwnCompany"
                                >
                                    <span class="mx-2"
                                        >Own Company</span
                                    ></b-form-checkbox
                                ></b-col
                            >
                            <!-- <b-col md="10">
                                <b-form-file
                                    @change="readLogo"
                                    :state="Boolean(organization.logo)"
                                    placeholder="Choose a file..."
                                    drop-placeholder="Drop file here..."
                                ></b-form-file>
                            </b-col> -->
                            <!-- <b-col md="10">
                                <GmapAutocomplete
                                    @place_changed="(e) => this.setPlace(e)"
                                    class="mt-1 location-search"
                                ></GmapAutocomplete>
                            </b-col>
                            <b-col md="10">
                                <eb-select
                                    type="text"
                                    v-model="organization.orgAccessLevel"
                                    :options="orgAccessOptions"
                                    @input="changeLevel"
                                    label="label"
                                    placeholder="Select org Access Level"
                                ></eb-select>
                            </b-col>
                            <b-col
                                md="10"
                                v-if="
                                    organization.orgAccessLevel &&
                                    organization.orgAccessLevel.value ===
                                        'Limited'
                                "
                            >
                                <multiselect
                                    v-model="organization.orgAccessList"
                                    tag-placeholder="Add this as new org Access"
                                    placeholder="Select org Access List"
                                    label="userName"
                                    track-by="userName"
                                    :options="orgAccessListOptions"
                                    :multiple="true"
                                    :taggable="false"
                                    :open-direction="'top'"
                                ></multiselect>
                            </b-col> -->
                        </b-row>
                    </b-col>
                    <!-- //////////// -->
                    <b-col md="4" class="mr-1 mt-2">
                        <GmapMap
                            :center="position"
                            :zoom="7"
                            map-type-id="terrain"
                            style="width: 340px; height: 340px"
                        >
                            <GmapMarker
                                label="★"
                                :draggable="true"
                                :position="position"
                            />
                        </GmapMap>
                    </b-col>
                </b-row>
            </div>
            <!-- ///////////////////////////////////////////// -->
            <!-- <hr style="border-top: 1px solid var(--primary)" class="mt-3" /> -->
            <!-- /////////////////////////////////////////////////////////////////////////// -->
            <div class="mt-4" v-if="false">
                <h3 style="color: #2c8ef8; margin-bottom: 20px">Bill To</h3>
                <b-row class="align-items-end">
                    <b-col md="3">
                        <eb-select
                            type="text"
                            label="label"
                            placeholder="Select Category"
                            v-model="billTo.officeType"
                            :options="officeOptions"
                            :selected="billTo.officeType"
                            :disabled="true"
                        />
                    </b-col>
                    <b-col md="4">
                        <slot name="name">
                            <c-input
                                readonly
                                inputType="text"
                                inputId="userName"
                                lableText="Office Name"
                                v-model="billTo.officeName"
                            />
                        </slot>
                    </b-col>
                    <b-col md="5">
                        <div
                            v-for="(p, idx) in billTo.phone"
                            :key="idx"
                            class="d-flex align-items-center"
                        >
                            <div class="flex-grow-1 pr-2">
                                <c-tel-input
                                    :disabled="true"
                                    v-model="p.number"
                                    @validate="(e) => isValidate(e, p)"
                                    :defaultInput="p.number"
                                />
                            </div>
                            <!-- <div>
                                <b-button
                                    :class="[
                                        'add button',
                                        p.isRemovable
                                            ? 'btn-danger'
                                            : 'btn-primary',
                                    ]"
                                    size="lg"
                                    @click="onClickPhoneButtonBill(p, idx)"
                                >
                                    <i
                                        :class="
                                            p.isRemovable
                                                ? 'fa fa-minus-circle mr-1'
                                                : 'fa fa-plus-circle mr-1'
                                        "
                                    ></i>
                                    {{ p.isRemovable ? "Remove" : "Add" }}
                                </b-button>
                            </div> -->
                        </div>
                    </b-col>
                </b-row>
                <!-- //////////////// -->
                <b-row>
                    <b-col md="3">
                        <eb-select
                            label="name"
                            @input="getCountryBill"
                            :options="countries"
                            placeholder="Country"
                            :selected="billTo.address.country"
                            disabled
                        ></eb-select>
                    </b-col>
                    <b-col md="4">
                        <eb-select
                            disabled
                            label="name"
                            @input="getStateBill"
                            :options="states"
                            placeholder="State"
                            :selected="billTo.address.state"
                        ></eb-select>
                    </b-col>
                    <b-col md="5">
                        <div
                            v-for="(e, idx) in billTo.email"
                            :key="idx"
                            class="d-flex align-items-center mb-2"
                        >
                            <div class="flex-grow-1 pr-2">
                                <c-input
                                    readonly
                                    inputType="text"
                                    inputId="email"
                                    lableText="Email"
                                    v-model="e.mailId"
                                />
                            </div>
                            <!-- <div>
                                <b-button
                                    :class="[
                                        'add button',
                                        e.isRemovable
                                            ? 'btn-danger'
                                            : 'btn-primary',
                                    ]"
                                    size="lg"
                                    @click="onClickEamilButtonBill(e, idx)"
                                >
                                    <i
                                        :class="
                                            e.isRemovable
                                                ? 'fa fa-minus-circle mr-1'
                                                : 'fa fa-plus-circle mr-1'
                                        "
                                    ></i>
                                    {{ e.isRemovable ? "Remove" : "Add" }}
                                </b-button>
                            </div> -->
                        </div>
                    </b-col>
                </b-row>
                <!-- //////////// -->
                <b-row>
                    <b-col md="3">
                        <eb-select
                            disabled
                            placeholder="City"
                            :options="cities"
                            label="name"
                            @input="getCityBill"
                            :selected="billTo.address.city"
                        ></eb-select>
                    </b-col>
                    <b-col md="4">
                        <c-input
                            readonly
                            type="text"
                            inputId="zipcode"
                            v-model="billTo.address.zip"
                            lableText="Zipcode"
                        />
                    </b-col>
                    <!-- <b-col md="4">
            <c-input
              type
              inputId="street"
              lableText="Street Line 1"
              v-model="billTo.address.street1"
            />
          </b-col> -->
                    <!-- <b-col md="4">
            <c-input
              inputType="text"
              inputId="address"
              lableText="Street Line 2"
              v-model="billTo.address.street2"
            />
          </b-col> -->
                </b-row>
                <!-- ///////////// -->
                <b-row>
                    <!-- <b-col md="4">
            <c-input
              type="text"
              inputId="hno"
              v-model="billTo.address.houseNumber"
              lableText="House Number"
            />
          </b-col> -->
                </b-row>
            </div>
            <!-- ////////////////////////////////////////////////////////////////////////////// -->
            <hr style="border-top: 1px solid var(--primary)" class="mt-4" />
            <!-- ///////////////////////////////////////////////////////////////////////////////////// -->
            <div>
                <h3 style="color: #2c8ef8; margin-bottom: 20px">
                    Authentication
                </h3>
                <b-row>
                    <b-col md="3">
                        <c-tel-input
                            disabled
                            v-model="authentication.phone"
                            :defaultInput="authentication.phone"
                            class="m-0"
                        />
                    </b-col>
                    <b-col md="4">
                        <c-input
                            readonly
                            inputType="text"
                            inputId="username"
                            lableText="User Name"
                            v-model="authentication.userName"
                        />
                    </b-col>
                    <b-col md="4"
                        ><c-input
                            readonly
                            style="width: 250px"
                            inputType="text"
                            inputId="email"
                            lableText="Email"
                            v-model="authentication.email"
                        />
                    </b-col>
                </b-row>
                <!-- ///// -->
                <b-row>
                    <!-- <b-col md="4">
            <c-input
              inputType="password"
              inputId="pwd"
              lableText="Password"
              v-model="authentication.password"
            />
          </b-col> -->
                    <b-col md="3">
                        <eb-select
                            disabled
                            :label="'text'"
                            placeholder="Security Question"
                            :options="securityQuestions"
                            :v-model="
                                (authentication &&
                                    authentication.securityQuestions &&
                                    authentication.securityQuestions
                                        .question) ||
                                ''
                            "
                            :selected="
                                (authentication &&
                                    authentication.securityQuestions &&
                                    authentication.securityQuestions
                                        .question) ||
                                ''
                            "
                        ></eb-select>
                    </b-col>
                    <b-col md="4">
                        <c-input
                            readonly
                            inputType="text"
                            inputId="sqa"
                            lableText="Security Question Answers"
                            :v-model="
                                (authentication &&
                                    authentication.securityQuestions &&
                                    authentication.securityQuestions.answer) ||
                                ''
                            "
                        />
                    </b-col>
                </b-row>
            </div>
        </b-card>
        <b-row v-if="!thankOrEdit">
            <b-col md="3"> </b-col>
            <b-col md="6">
                <b-card
                    border-variant="info"
                    header-bg-variant="primary"
                    header-text-variant="white"
                    class="full-width"
                >
                    <div slot="header">
                        <strong style="font-size: 20px"> Edit Office</strong>
                    </div>
                    <s-thanks @done="done"></s-thanks>
                </b-card>
            </b-col>
            <b-col md="3"> </b-col>
        </b-row>
    </div>
</template>
<script>
import cInput from "@/components/Common/CustomInput";
import cTelInput from "@/components/Common/MobileNumberInput";
import csc from "country-state-city";
import ebSelect from "@/components/FormElements/Select";
import cInputForm from "@/components/FormElements/CustomInput";
import { getReverseGeoCode } from "@/services/geocode";
import sThanks from "@/components/Office/ThankYouEdit.vue";
import Vue from "vue";
export default {
    name: "ViewOffice",

    data() {
        return {
            loading: false,
            thankOrEdit: true,
            securityQuestions: [
                {
                    text: "what is your mother maiden name",
                    value: "what is your mother maiden name",
                },
                {
                    text: "what is your first school",
                    value: "what is your first school",
                },
                { text: "your first car model", value: "your first car model" },
            ],

            // organization: {
            //     name: "",
            //     logo: "",
            //     orgAccessLevel: "",
            //     orgAccessList: null,
            // },
            position: {
                lat: 0,
                lng: 0,
            },
            countries: [],
            states: [],
            cities: [],
            tenant: null,
        };
    },
    components: {
        cInput,
        cTelInput,
        ebSelect,
        cInputForm,
        sThanks,
    },
    computed: {
        orgAccessOptions() {
            return [
                {
                    label: "Global",
                    value: "Global",
                },
                {
                    label: "Limited",
                    value: "Limited",
                },
            ];
        },
        orgAccessListOptions() {
            let data = this.$store.getters["partner/GetPartnerList"];
            let tenantList = [];
            if (Array.isArray(data) && data.length > 0) {
                data.map((obj) => {
                    if (obj.category === "OFFICE") {
                        let arrayObj = {
                            _id: obj._id,
                            userName: obj.authentication.userName,
                            email: obj.authentication.email,
                            phone: obj.authentication.phone,
                            password: "",
                            ...obj,
                        };
                        tenantList.push(arrayObj);
                    }
                });
                return tenantList;
            } else {
                return [];
            }
        },
        billTo() {
            return this.$store.getters["partner/GetPartnerData"].bill_to || {};
        },
        office() {
            return this.$store.getters["partner/GetPartnerData"].office || {};
        },
        authentication() {
            return (
                this.$store.getters["partner/GetPartnerData"].authentication ||
                {}
            );
        },
        organization() {
            return (
                this.$store.getters["partner/GetPartnerData"].organization || {}
            );
        },
        officeOptions() {
            return [
                {
                    label: "Default",
                    value: "DEFAULT",
                },
                {
                    label: "Head Office",
                    value: "HEAD_OFFICE",
                },
                {
                    label: "Regional Office",
                    value: "REGIONAL_OFFICE",
                },
                {
                    label: "Branch Office",
                    value: "BRANCH_OFFICE",
                },
            ];
        },
    },
    methods: {
        done() {
            this.$router.push("/office-management");
        },
        // async submitAllData() {
        //     try {
        //         const data = await getReverseGeoCode(
        //             `${this.office.address.street1},${this.office.address.city},${this.office.address.state},${this.office.address.country}`,
        //         );
        //         if (data.data.status === "OK") {
        //             this.office.address.location = {
        //                 coordinates: [
        //                     data.data.results[0].geometry.location.lat,
        //                     data.data.results[0].geometry.location.lng,
        //                 ],
        //             };
        //         }
        //     } catch (error) {}

        //     //////////////////////////////////////////////////////////
        //     try {
        //         const dataBill = await getReverseGeoCode(
        //             `${this.billTo.address.street1},${this.billTo.address.city},${this.billTo.address.state},${this.billTo.address.country}`,
        //         );
        //         if (dataBill.data.status === "OK") {
        //             this.billTo.address.location = {
        //                 coordinates: [
        //                     dataBill.data.results[0].geometry.location.lat,
        //                     dataBill.data.results[0].geometry.location.lng,
        //                 ],
        //             };
        //         }
        //     } catch (error) {}
        //     ////////////////////////////////////////////////////////////////////////////////
        //     const { organization, billTo, office, authentication } = this;
        //     const authenticationCopy = { ...authentication };
        //     authenticationCopy.securityQuestions = {
        //         question: authentication.securityQuestions.question,
        //         answer: authentication.securityQuestions.answer,
        //     };
        //     const tenant = this.$store.getters["auth/getUserID"];
        //     office.officeType = this.office.officeType.value;
        //     //delete authenticationCopy.securityQA;
        //     delete organization.location;
        //     delete authenticationCopy.password;
        //     delete organization.orgAccessLevel;
        //     delete organization.orgAccessList;
        //     const payload = {
        //         id: this.$store.getters["partner/GetPartnerData"]._id,
        //         data: {
        //             authentication: authenticationCopy,
        //             billTo,
        //             office,
        //             organization,
        //             tenant,
        //             agreement: {
        //                 doc: "test",
        //             },
        //             category: "OFFICE",
        //         },
        //     };
        //     this.loading = true;
        //     this.$store
        //         .dispatch("partner/updatePartner", payload)
        //         .then((result) => {
        //             this.loading = false;
        //             this.thankOrEdit = false;
        //             this.$swal({
        //                 title: "Success",
        //                 text: "Office Edited successfully!",
        //                 type: "success",
        //             });
        //         })
        //         .catch((error) => {
        //             this.loading = false;
        //             this.$swal({
        //                 title: "Error",
        //                 text: "Could not Edited office",
        //                 type: "error",
        //             });
        //         });
        //     //////////////////////////////////////////////////////////////////////////////
        // },
        async onClickPhoneButtonBill(item, idx) {
            const { isRemovable } = item;
            if (!isRemovable) {
                this.billTo.phone.push({
                    country: {
                        dialCode: null,
                        iso2: null,
                        name: null,
                    },
                    number: null,
                    type: "5cb701203aa1ea2920089568",
                    isRemovable: true,
                    text: "Remove",
                    isValid: false,
                });
            } else {
                this.billTo.phone.splice(idx, 1);
            }
        },
        async onClickEamilButtonBill(item, idx) {
            const { isRemovable } = item;
            if (!isRemovable) {
                this.billTo.email.push({
                    mailId: "",
                    type: "5cb701203aa1ea2920089568",
                    isRemovable: true,
                    text: "Remove",
                });
            } else {
                this.billTo.email.splice(idx, 1);
            }
        },

        getCountryBill(payload) {
            this.setState(payload.id);
            this.billTo.address.country = payload.name;
        },
        getStateBill(payload) {
            this.setCity(payload.id);
            this.billTo.address.state = payload.name;
        },
        getCityBill(payload) {
            this.billTo.address.city = payload.name;
        },
        async setPlace(p) {
            let place = await p;
            let position = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            };
            this.position = position;
        },
        readLogo(e) {
            const reader = new FileReader();
            reader.readAsDataURL(e.target.files[0]);
            reader.onload = () => {
                this.uploadImage(reader.result);
            };
            reader.onerror = (err) => {};
        },
        // upload images to the S3 bucket
        // async uploadImage(image) {
        //     let dataobj = {
        //         image: image,
        //         key: (
        //             Date.now().toString(36) +
        //             Math.random().toString(36).substr(2, 5)
        //         ).toLowerCase(),
        //         isPublic: true,
        //         replaceExisting: true,
        //         basePath: "tenant",
        //     };
        //     this.showCustomToast();
        //     await this.$store
        //         .dispatch("inventory/uploadImageToStorage", dataobj)
        //         .then((res) => {
        //             if (res) {
        //                 this.clearCustomToast();
        //                 this.organization.logo = res.data.fileUrl;
        //             }
        //         })
        //         .catch((error) => {
        //             this.clearCustomToast();
        //             this.$toasted.error(
        //                 "Image not uploaded..please try again!",
        //             );
        //         });
        // },
        showCustomToast() {
            Vue.toasted.show("Uploading...", {
                type: "info",
                theme: "toasted-primary",
                singleton: true,
                duration: 1000000,
            });
        },
        clearCustomToast() {
            Vue.toasted.clear();
        },
        changeLevel(event) {
            if (event.value === "Global") {
                this.organization.orgAccessList = null;
            }
        },
        isValidate(e, p) {
            p.country = { ...e.country };
            p.isValid = e.isValid;
        },
        getCountry(payload) {
            this.setState(payload.id);
            this.office.address.country = payload.name;
        },
        getState(payload) {
            this.setCity(payload.id);
            this.office.address.state = payload.name;
        },
        getCity(payload) {
            this.office.address.city = payload.name;
        },
        async setCountry() {
            this.countries = await csc.getAllCountries();
        },
        async setState(id) {
            this.states = await csc.getStatesOfCountry(id);
        },
        async setCity(id) {
            this.cities = await csc.getCitiesOfState(id);
        },
        async onClickEamilButton(item, idx) {
            const { isRemovable } = item;
            if (!isRemovable)
                this.office.email.push({
                    mailId: "",
                    type: "5cb701203aa1ea2920089568",
                    isRemovable: true,
                    text: "minus",
                });
            else this.office.email.splice(idx, 1);
        },
        async onClickPhoneButton(item, idx) {
            const { isRemovable } = item;
            if (!isRemovable)
                this.office.phone.push({
                    country: {
                        dialCode: null,
                        iso2: null,
                        name: null,
                    },
                    number: null,
                    type: "5cb701203aa1ea2920089568",
                    isRemovable: true,
                    text: "minus",
                });
            else this.office.phone.splice(idx, 1);
        },
    },
    async mounted() {
        await this.$store.dispatch(
            "partner/fetchOfficerById",
            this.$route.params.officeId,
        );
        this.setCountry();
        // this.$store.dispatch("partner/fetchPartnersList");
        this.office.phone.forEach((p) => {
            if (!p.text) {
                p.text = p.isRemovable ? "Remove" : "Add";
            }
        });
        // this.organization =
        //     this.$store.getters["partner/GetPartnerData"].organization;
        // this.billTo = this.$store.getters["partner/GetPartnerData"].office;
        // this.authentication.phone =
        //     this.$store.getters["partner/GetPartnerData"].authentication.phone;
        // this.authentication.email =
        //     this.$store.getters["partner/GetPartnerData"].authentication.email;
        // this.authentication.userName =
        //     this.$store.getters[
        //         "partner/GetPartnerData"
        //     ].authentication.userName;
        // this.authentication.securityQuestions =
        //     this.$store.getters[
        //         "partner/GetPartnerData"
        //     ].authentication.securityQuestions;
        // this.authentication.password =
        //     this.$store.getters[
        //         "partner/GetPartnerData"
        //     ].authentication.password;

        this.position.lat =
            this.$store.getters[
                "partner/GetPartnerData"
            ].office.address.location.coordinates[1];
        this.position.lng =
            this.$store.getters[
                "partner/GetPartnerData"
            ].office.address.location.coordinates[0];
    },
};
</script>
<style scoped>
[btn-color="primary"] {
    height: 41px;
    background-color: var(--primary);
    font-weight: 600;
    font-size: medium;
    letter-spacing: 2px;
    font-family: "Lato";
    color: white;
    border: 0px;
    border-radius: 0px;
}

[btn-special="primary"] {
    border: 0px;
    font-weight: 500;
    letter-spacing: 1px;
    font-size: medium;
    font-family: "Lato";
    border-radius: 0px;
    height: 39px;
    width: 132px;
    background-color: var(--primary);
    color: white;
}
.btn-special {
    border: 0px;
    font-weight: 500;
    letter-spacing: 1px;
    font-size: medium;
    font-family: "Lato";
    border-radius: 0px;
    height: 39px;
    width: 132px;
    background-color: #2433d7;
    color: white;
}
.back-btn {
    font-weight: bold;
    float: right;
}
.back-btn:hover {
    background-color: #24a07d;
}
.statemargintop {
    margin-top: -15px !important;
}
.streetmargintop {
    margin-top: -8px !important;
}
</style>
<style>
.vue-tel-input {
    border-radius: 0px !important;
    height: 39px !important;
    border: 1px solid #dee2e6 !important;
}

.location-search {
    border-radius: 0rem;
    color: rgb(0, 0, 0);
    box-shadow: none !important;
    font-family: "Lato";
    height: 39px !important;
    border: 1px solid #dee2e6;
    padding-left: 10px;
    width: 100%;
    font-size: small;
}

.custom-file-label {
    border-radius: 0px !important;
    border: 1px solid #dee2e6 !important;
    color: #dee2e6 !important;
}
.sqanswer {
    margin-top: -12px !important;
}
.footer-bottons-class {
    margin-top: 50px;
    text-align: center;
    margin-left: 40%;
}
.back.button {
    position: absolute;
    right: 24px;
    background-color: #2d2dee;
    color: white;
    border: 1px solid white;
    transition: all 0.3s ease-in-out;
}
.back.button:hover {
    background-color: #1a1aad;
    color: white;
    border: 1px solid #ffffff;
}

.add.button {
    width: 100px;
    margin-bottom: 15px;
}
.add.button {
    width: auto;
    min-width: 110px;
    margin-bottom: 15px;
    white-space: nowrap;
}
.img-thumbnail {
    border-radius: 0px !important;
    border: 1px solid #dee2e6 !important;
    min-width: 200px;
    min-height: 200px;
    max-width: 200px;
    max-height: 200px;
    margin: auto;
}
</style>
